import { AxiosInstance } from 'axios';

const analyticApi = (http: AxiosInstance) => ({
    async tracking(entity: string, action: string) {
        const response = await http.post('analytic/tracking', {
            entity,
            action,
        });

        return response.data;
    },
});

export default analyticApi;
